function AddCart_ProteinOcean({ item }) {
  return (
    <>
      <img src={item?.placeholderImage} className={` w-full `} />
    </>
  );
}

export default AddCart_ProteinOcean;
